<template>

    <MarketHeader :selectedHeader="useHeader" />

    <router-view />

		<BackGround/>

</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import BackGround from '@/components/design/background.vue';

import MarketHeader from '@/components/header/header.vue';

export default defineComponent({
  name: 'CheckoutLayout',
  components: {
    MarketHeader,
    BackGround,
  },
  setup() {
    const route = useRoute();
    const useHeader = computed(() => {
      const name = route.name ? String(route.name) : '';
      return name === 'BookingSuccess' || name === 'BookingKo' ? 'searchHeader' : 'checkoutHeader';
    });

    return {
      useHeader,
    };
  },
});
</script>

<style scoped>

@import "../assets/css/helper.css";
@import "../assets/css/owl.carousel.min.css";
@import "../assets/css/responsive.css";
@import "../assets/css/style.css";

</style>
